/*<FilteredTable
            redirectNamespace={`${url}/missions`}
            data={filteredMissions.data}
            handleAddHandler={this.navigateToCreate.bind(this, campaignId)}
            columns={this.getColumns()}
            filterComponent={
              <SectionFilter
                filters={filterOptions}
                handleChangeFilter={this.handleChangeFilter}
                handleSearch={this.handleSearch}
              />
            }
            footerRows={[<Tr>
              <Td></Td>
              <Td></Td>
              <Td></Td>
              <Td></Td>
              <Td></Td>
              <Td></Td>
              <Td></Td>
              <Td className='bold'>{numberWithCommas(totals.flyersDistributed)}</Td>
              <Td></Td>
              <Td></Td>
            </Tr>]}
          />*/

import React, { Component, Fragment } from 'react'
import { Table } from 'Components/Table'
import { Td } from 'Components/Table/Td'
import { Th } from 'Components/Table/Th'
import { Tr } from 'Components/Table/Tr'

/**
 * Accepts
 * @param {Array<string>} headers
 * @param {Array<Array<string>>} data
 * @param {Function} onLoadMore
 * @param {boolean} loading Pass this in as true to show a loading indicator
 */
class InfiniteScrollingTable extends Component {
  componentDidMount = () => {
    window.addEventListener('scroll', this.onScroll)
  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.onScroll)
  }

  onScroll = () => {
    const { onLoadMore, loading } = this.props
    var bounds = this.table_.getBoundingClientRect()

    const distFromBottom = bounds.bottom - window.innerHeight
    //console.log('distFromBottom', distFromBottom)
    if (loading !== true && onLoadMore && distFromBottom <= 0) onLoadMore()
  }

  render = () => {
    const { loading, hasNextPage, headers, data, onLoadMore } = this.props

    return (
      <div ref={el => (this.table_ = el)}>
        <Table>
          <TableHead data={headers} />
          <TableBody data={data} />
          {loading ? (
            <tbody>
              <Tr>
                <td
                  style={{
                    color: '#c1c1c1',
                    textAlign: 'center',
                  }}
                  colSpan={headers.length}
                >
                  Loading...
                </td>
              </Tr>
            </tbody>
          ) : (
            <Fragment>
              {hasNextPage ? (
                <tbody>
                  <Tr>
                    <td
                      onClick={() => onLoadMore()}
                      style={{
                        color: '#c1c1c1',
                        textAlign: 'center',
                        cursor: 'pointer',
                      }}
                      colSpan={headers.length}
                    >
                      Click here or scroll bottom to load more items
                    </td>
                  </Tr>
                </tbody>
              ) : (
                <tbody>
                  <Tr>
                    <td
                      style={{
                        color: '#c1c1c1',
                        textAlign: 'center',
                      }}
                      colSpan={headers.length}
                    >
                      No more items left
                    </td>
                  </Tr>
                </tbody>
              )}
            </Fragment>
          )}
        </Table>
      </div>
    )
  }
}

export default InfiniteScrollingTable

const TableHead = ({ data }) => (
  <thead>
    <Tr>
      {data.map((h, index) => (
        <Th key={index + '_Th'}>{h}</Th>
      ))}
    </Tr>
  </thead>
)

const TableBody = ({ data }) => (
  <tbody>
    {data.map((row, index) => (
      <Tr key={index + '_Tr'}>
        {row.map((c, index) => (
          <Td key={index + '_Td'}>{c}</Td>
        ))}
      </Tr>
    ))}
  </tbody>
)



// WEBPACK FOOTER //
// ./src/Components/InfiniteScrollingTable/index.js